import React from 'react';
import { useHistory } from 'react-router-dom'; 
import { Dialog, DialogTitle, DialogContent, TextField, Button, DialogActions, Box, Typography } from '@mui/material';
import { useState } from 'react';
import axios from 'axios';

function Videos() {
  const history = useHistory(); 
  const [open, setOpen] = useState(false);
  const [videoFile, setVideoFile] = useState(null);
  const [description, setDescription] = useState("");
  const [title, setTitle] = useState("");

  const handleUpload = async () => {
    if (!videoFile) return;

    const formData = new FormData();
    formData.append('video', videoFile);
    formData.append('description', description);
    formData.append('title', title);

    try {
      const res = await axios.post('/videos/upload', formData);
      console.log("Upload success:", res.data);
      setOpen(false); // close dialog
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  return (
    <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                      <Button 
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/videos/popularVideos')}
                      >
                        Popular
                      </Button>
                      <Button 
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/videos/followingVideos')}
                      >
                        Following
                      </Button>
                      <Button 
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => setOpen(true)}
                      >
                        Post Video
                      </Button>
                      
        {/*<Button variant="contained" onClick={() => history.push('/videos/popularVideos')}>
          Popular
        </Button>
        <Button variant="contained" onClick={() => history.push('/videos/followingVideos')}>
          Following
        </Button>
        <Button variant="contained" onClick={() => history.push('/videos/recommendedVideos')}>
          Recommended
        </Button>
        <Button variant="contained" onClick={() => setOpen(true)}>
          Post Video
        </Button>*/}

        <Dialog open={open} onClose={() => setOpen(false)}>
          <DialogTitle>Upload a Video</DialogTitle>
          <DialogContent>
            <input
              type="file"
              accept="video/*"
              onChange={(e) => setVideoFile(e.target.files[0])}
              style={{ marginTop: 16 }}
            />
            <TextField
              label="Title"
              fullWidth
              multiline
              rows={3}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              sx={{ mt: 2 }}
            />
            <TextField
              label="Description"
              fullWidth
              multiline
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{ mt: 2 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={handleUpload} variant="contained">Upload</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </div>
  );
}

export default Videos;
